/**
 * Sorting text the way this app's users read it.
 *
 * Everything sortable here is German — Maßnahmentitel, Gemarkungen, people's
 * names — and almost everything is at least partly a number: Befund 2 before
 * Befund 10, "Planum 1, Teil A" before "Planum 1, Teil B". The browser default
 * (`a.localeCompare(b)`) gets both wrong: it sorts by the visitor's locale, and
 * it sorts "10" before "2".
 *
 * There were a hundred-odd `localeCompare` calls across the app and they did
 * not agree — a third passed `'de'` alone, so the same Maßnahmennummer sorted
 * numerically in one import and lexically in another.
 */

/** German collation, digits compared as numbers. The default for anything numbered. */
export function compareNatural(left: string, right: string): number {
    return left.localeCompare(right, 'de', { numeric: true });
}

/**
 * German collation, plain — for text that carries no numbers worth reading as
 * such (a Gemarkung, a person's name, a free-text label).
 */
export function compareText(left: string, right: string): number {
    return left.localeCompare(right, 'de');
}
